import { createContext, useContext, useState, useEffect } from "react";
import SessionExpireModal from "./SessionExpireModal";

const SessionExpireContext = createContext();

export const SessionExpireProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const showSessionExpirePopup = () => setOpen(true);
  const hideSessionExpirePopup = () => setOpen(false);

  // Listen for global event fired from API services
  useEffect(() => {
    const handler = () => showSessionExpirePopup();
    window.addEventListener("session-expired", handler);

    return () => window.removeEventListener("session-expired", handler);
  }, []);

  return (
    <SessionExpireContext.Provider
      value={{ open, showSessionExpirePopup, hideSessionExpirePopup }}
    >
      {/* 🔥 Render your modal here */}
      <SessionExpireModal open={open} />

      {children}
    </SessionExpireContext.Provider>
  );
};

export const useSessionExpire = () => useContext(SessionExpireContext);
